import React, { Component, Fragment } from "react";

import {
    Typography,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell
} from "@material-ui/core";

export default class BarChart extends Component {
    render() {
        const { timesheets, title, day } = this.props;

        return (
            <Fragment>
                <Typography
                    variant="headline"
                    align="center"
                    style={{
                        border: "1px solid blue",
                        borderRadius: "24px",
                        padding: 4
                    }}
                >
                    <b>{title}</b>
                </Typography>

                <Table padding="dense" style={{ width: "100%" }}>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell text="User Name" />
                            <TableHeadCell text="Start Time" />
                            <TableHeadCell text="End Time" />
                            <TableHeadCell text="Time On Lunch" />
                            <TableHeadCell text="Total Time" />
                            <TableHeadCell text="Vehicle Reg" />
                            <TableHeadCell text="Location" />
                            <TableHeadCell text="Working hours" />
                            <TableHeadCell text="Hours to be paid" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {typeof timesheets !== "undefined" &&
                            timesheets &&
                            timesheets.map((e, i) => {
                                return (
                                    e.timesheets[day] &&
                                    e.timesheets[day].map(time => {
                                        return (
                                            <TableRow key={i}>
                                                <TableBodyCell
                                                    text={`${e.name}`}
                                                />
                                                <TableBodyCell
                                                    text={time.time_in}
                                                />
                                                <TableBodyCell
                                                    text={time.time_out}
                                                />
                                                <TableBodyCell
                                                    text={time.time_on_lunch}
                                                />
                                                <TableBodyCell
                                                    text={time.total}
                                                />
                                                <TableBodyCell
                                                    text={time.vehicle_reg}
                                                />
                                                <TableBodyCell
                                                    text={
                                                        time.works_location_client
                                                    }
                                                />
                                                <TableBodyCell
                                                    text={time.working_hours}
                                                />
                                                <TableBodyCell
                                                    text={time.hours_to_be_paid}
                                                />
                                            </TableRow>
                                        );
                                    })
                                );
                            })}
                    </TableBody>
                </Table>
            </Fragment>
        );
    }
}
const TableHeadCell = props => {
    return (
        <TableCell>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
const TableBodyCell = props => {
    return (
        <TableCell>
            <Typography variant="body2">{props.text}</Typography>
        </TableCell>
    );
};
